<div
  class="search-bar"
  [class.search-active]="searchInput.value || inputFocus()"
  (click)="searchInput.focus()"
>
  <mat-icon class="search" svgIcon="icon_search_24" />
  <input
    #searchInput
    type="search"
    class="w-full"
    (input)="onInputChange(searchInput.value, false)"
    (focus)="inputFocus.set(true)"
    (blur)="inputFocus.set(false)"
    (keydown.enter)="onInputChange(searchInput.value, true)"
    placeholder="Search messages"
    data-cy="Chat:searchMessages:field"
  />
  <button blazeIconButton="skeleton" (click)="clear(searchInput)">
    <mat-icon class="clear" svgIcon="close" />
  </button>
</div>
